module.exports = __webpack_public_path__ + "static/news-banner-d47415124f5d638006a09c5d3bd250fd.png";